export default __webpack_public_path__ + "static/media/SDG-icon-NL-14.69aea72b.svg";